// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import './index.css'

export default class Title extends Component {
  renderRightTitle = () => {
    return (
      <div className='component-title'>
        <div className='row title text-center'>
          <div className='col-md-10'>
            <hr/>
          </div>
          <div className='col-md-2 text'>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }

  renderLeftTitle = () => {
    return (
      <div className='component-title'>
        <div className='row title text-center'>
          <div className='col-md-2 text'>
            {this.props.children}
          </div>
          <div className='col-md-10'>
            <hr/>
          </div>
        </div>
      </div>
    )
  }

  renderCenterTitle = () => {
    return (
      <div className='component-title'>
        <div className='row title text-center'>
          <div className='col-md-5'>
            <hr/>
          </div>
          <div className='col-md-2 text'>
            {this.props.children}
          </div>
          <div className='col-md-5'>
            <hr/>
          </div>
        </div>
      </div>
    )
  }

  renderTitle = () => {
    switch (this.props.format) {
      case 'center':
        return this.renderCenterTitle()

      case 'left':
        return this.renderLeftTitle()

      case 'right':
        return this.renderRightTitle()

      default:
        return this.renderCenterTitle()
    }
  }

  render () {
    return (
      <div className='container-fluid title-container'>
        {this.renderTitle()}
      </div>
    )

  }
}
